import * as React from 'react';
import UserStore from 'stores/UserStore';
import {observer} from 'mobx-react';
import {ProfileEdit} from 'components/Profile';
import {ProfileUser} from 'components/Profile/types';
import AuthStore from 'stores/AuthStore';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {toast} from 'react-toastify';
import {Helmet} from 'react-helmet';

/**
 * The courses page
 * @constructor
 */
function Settings(): React.ReactElement {
  /**
   * This submit event handler.
   * @param {ProfileUser} data
   */
  function handleSubmit(data: ProfileUser): void {
    UserStore.state && UserStore.save({
      ...UserStore.state,
      name: data.name,
      username: data.nickname,
      avatar: data.avatar || null,
    }).then((response) => {
      validateResponse(response);

      if (response && !isError(response)) {
        AuthStore.token && (
          AuthStore.fetch(AuthStore.token)
        );
        toast.success('Настройки сохранены!');
      }
    });
  }

  const user: ProfileUser | undefined = UserStore.state ? {
    name: UserStore.state.name,
    nickname: UserStore.state.username,
    avatar: UserStore.state.avatar ? (
      UserStore.state.avatar
    ) : undefined,
    contacts: {
      phone: UserStore.state.contacts?.phone,
      email: UserStore.state.email,
    },
  } : undefined;

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Настройки</title>
      </Helmet>
      {user ? (
        <ProfileEdit
          user={user}
          onSubmit={handleSubmit}
        />
      ) : undefined}
    </React.Fragment>
  );
}

export default observer(Settings);
